import * as React from 'react';

import { StatusChip } from '@occc/ui-design-system';
import { Publication_Status_Type, Published_Status_Type } from '@occc/graphql';

// Legacy badge for the `publicationStatus` field, which has no native ARCHIVED state and
// infers it from a separate `deleted` flag. Still used by the Game, LoyaltyEvent, and
// AwardCatalog tables; remove once they migrate to `publishedStatusBadge` below.
type StatusBadgeParams = (
  isArchived: boolean,
  publicationStatus: Publication_Status_Type,
) => React.ReactNode;

export const statusBadge: StatusBadgeParams = (isArchived, publicationStatus) => {
  if (publicationStatus === Publication_Status_Type.Expired) {
    return <StatusChip label='Expired' variant='error' />;
  }

  if (publicationStatus === Publication_Status_Type.Unpublished) {
    return <StatusChip label='Unpublished' variant='warning' />;
  }

  if (isArchived) {
    return <StatusChip label='Archived' variant='disabled' />;
  }

  return <StatusChip label='Published' variant='success' />;
};

// Renders a badge from the `publishedStatus` field, which reports ARCHIVED natively
// (unlike `publicationStatus`, which collapses archived offers into UNPUBLISHED).
export const publishedStatusBadge = (publishedStatus: Published_Status_Type): React.ReactNode => {
  switch (publishedStatus) {
    case Published_Status_Type.Archived:
      return <StatusChip label='Archived' variant='disabled' />;
    case Published_Status_Type.Expired:
      return <StatusChip label='Expired' variant='error' />;
    case Published_Status_Type.Unpublished:
      return <StatusChip label='Unpublished' variant='warning' />;
    case Published_Status_Type.Published:
      return <StatusChip label='Published' variant='success' />;
    default:
      return <StatusChip label='Unknown' variant='default' />;
  }
};
